import React from "react";
import { Layout, TeamBonus } from "../components";

const TeamBonusPage = () => {
  return (
    <>
      <Layout>
        <TeamBonus />
      </Layout>
    </>
  );
};

export default TeamBonusPage;
